<div id="page-wrapper" class="page-wrapper toggled-sidebar" *mobxAutorun>
    <dashboard-nav [user]="store?.user" [term]="env?.term" (onSignOut)="store?.signOut()">
    </dashboard-nav>
    <main-sidebar [appName]="APP_NAME" [menu]="APP_OPTIONS" *ngIf="user"></main-sidebar>
    <main id="main" class="puc-app" >
        <router-outlet *ngIf="user"></router-outlet>
    </main>
</div>
